<template>
    <div v-loading.fullscreen="isLoading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.6)" class="tt_work_list">
        <div @touchmove.prevent="" class="work_list_head">
            <div class="head_left">
                <span>同同作业</span>
                <div class="head_filter">
                    <div v-show="type.id !== '4'" v-for="(type, index) in typeList" :key="index" class="head_filter_btn" @click="changeType(type)" :class="{'btn_active': type.select, 'btn_col': index && !type.select && !typeList[index - 1].select}">{{type.name}}</div>
                </div>
            </div>
            <div class="head_right">
                <el-dropdown trigger="click" @command="commandChange">
                    <span class="el-dropdown-link">
                        <span>{{$store.state.work.activeSchoolYear && $store.state.work.activeSchoolYear.name || '请选择学年'}}</span>
                        <img class="change_icon" src="../../assets/image/ttWork/list/change.png" alt="">
                    </span>
                    <el-dropdown-menu slot="dropdown" class="tt_work_list_dropdown_schoolYear">
                        <el-dropdown-item v-for="item in schoolYearList" :class="{'active': $store.state.work.activeSchoolYear.id === item.id}" :key="item.id" :command="item">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-infinite-scroll="loadPaperList"
             :infinite-scroll-immediate="false"
             :infinite-scroll-distance="10"
             :infinite-scroll-disabled="isLoading || this.totalNum < 2 || this.pageNum >= this.totalNum" ref="listScroll" class="work_list_scroll" style="overflow: auto">
            <div class="list_scroll_content">
<!--                v-show="paper.type !== 4"-->
                <paper-option
                        v-for="(paper, index) in paperList"
                        @click.native="goWorkDetail(paper)"
                        :is-parent="false"
                        :paper-info="paper" :key="index" class="scroll_paper"></paper-option>
                <div v-show="paperList.length" style="width: 416px"></div>
                <div v-show="paperList.length" style="width: 416px"></div>
                <empty-page v-show="!isLoading && !paperList.length" class="scroll_empty"></empty-page>
                <img class="scroll_content_background" src="../../assets/image/classroom/list/list-background.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TongTongWorkList",
        components: {
            PaperOption: () => import('./components/PaperOption'),
            EmptyPage: () => import('../../components/empty/EmptyPage')
        },
        data () {
            return {
                isLoading: false, // loading
                pageNum: 1, // 当前页数
                totalNum: 1, // 总页数
                pageSize: 24, // 单次请求条目数
                paperList: [], // 试卷列表
                activeType: {}, // 当前筛选的试卷类型
                schoolYearList: [], // 学年
                // 试卷类型
                typeList: [{name: '全部', id: '', select: false}, {name: '个性作业', id: '1', select: false}, {name: '常规作业', id: '2', select: false}, {name: '实时课堂', id: '3', select: false}, {name: '听说练习', id: '4', select: false}],
            }
        },
        async created () {
            this.isLoading = true;
            await this.getSchoolYear ();
            this.changeType(this.typeList[0])
        },
        activated () {
            if (this.$store.state.work.listScrollTop) {
                if (this.$refs.listScroll) {
                    this.$refs.listScroll.scrollTop = this.$store.state.work.listScrollTop;
                    this.$store.commit('workListScrollTop', null);
                }
            }
            if (this.$store.state.work.activePaper) {
                this.paperList.map(item => {
                    if (item.id === this.$store.state.work.activePaper.id) {
                        this.$set(item, 'informed', this.$store.state.work.activePaper.informed)
                    }
                })
            }
        },
        methods: {
            // 获取学年
            getSchoolYear () {
                return this.$https.post('/api/blog/student/schoolYear').then((response)=>{
                    if (response.code === 0) {
                        this.schoolYearList = response.data;
                        if (this.schoolYearList.length) {
                            this.$store.commit('workSchoolYear', this.schoolYearList[0]);
                        }
                    }
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors)
                });
            },
            commandChange (data) {
                if (data.id === this.$store.state.work.activeSchoolYear.id) return;
                this.$store.commit('workSchoolYear', data);
                this.initPaperList();
            },
            // 更改查看的试卷类型
            changeType (type) {
                if (type.select) return;
                this.typeList.forEach(i => {
                    i.select = false
                });
                type.select = true;
                this.activeType = type;
                this.initPaperList()
            },
            // 重置试卷列表
            initPaperList () {
                this.pageNum = 0;
                this.totalNum = 1;
                this.paperList = [];
                if (this.$refs.listScroll) {
                    this.$refs.listScroll.scrollTop = 0;
                }
                this.getPaperList();
            },
            // 无限加载
            loadPaperList () {
                // if (this.pageNum === 0) return;
                this.getPaperList();
            },
            // 获取试卷列表
            getPaperList () {
                this.isLoading = true;
                this.pageNum++;
                this.$https.get('/api/tk/ttwork/home/list', {
                    params: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                        schoolYear: this.$store.state.work.activeSchoolYear.id,
                        type: this.activeType.id
                    }
                }).then((response)=>{
                    if (response.code === 0) {
                        if (this.pageNum === 1) {
                            this.totalNum = Math.ceil(Number(response.data.total) / this.pageSize)
                        }
                        if (response.data.data && Array.isArray(response.data.data)) {
                            response.data.data.forEach(i => {
                                i.typeName = this.typeList[Number(i.type)].name;
                                if (i.type !== 4) {
                                    this.paperList.push(i)
                                }
                            })
                        }
                    }
                    this.isLoading = false;
                },(error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors)
                });
            },
            goWorkDetail (paper) {
                this.$store.commit('workListScrollTop', (this.$refs.listScroll && this.$refs.listScroll.scrollTop) || 0);
                this.$store.commit('workActivePaper', paper);
                this.$store.commit('workActiveClass', null);
                this.$router.push({path: '/ttWorkDetail'});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tt_work_list{
        height: 100%;
        .work_list_head{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            font-size: 22px;
            color: #333333;
            line-height: 36px;
            white-space: nowrap;
            box-sizing: border-box;
            .head_left{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .head_filter{
                    margin-left:42px;
                    background:rgba(219,219,219,1);
                    display: flex;
                    align-items: center;
                    border-radius:5px;
                    .head_filter_btn{
                        cursor: pointer;
                        height: 36px;
                        padding: 0 24px;
                        font-size: 14px;
                        color: white;
                        position: relative;
                    }
                    .btn_active{
                        background: #2196F3;
                        border-radius: 5px;
                    }
                    .btn_col:before{
                        content: '';
                        position: absolute;
                        width: 2px;
                        height: 18px;
                        top: 9px;
                        left: -1px;
                        background: white;
                    }
                }
            }
            .head_right{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 14px;
                color: #333333;
                .el-dropdown-link{
                    outline: none;
                    cursor: pointer;
                    .change_icon{
                        vertical-align: middle;
                    }
                    span{
                        vertical-align: middle;
                        display: inline-block;
                        margin-right: 5px;
                    }
                }
            }
        }
        .work_list_scroll{
            height: calc(100% - 100px);
            overflow: auto;
            .list_scroll_content{
                width: 1200px;
                margin: 0 auto;
                /*min-height: calc(100% + 1px);*/
                min-height: 100%;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;
                align-content: flex-start;
                justify-content: space-between;
                .scroll_paper{
                    /*float: left;*/
                    margin-bottom: 20px;
                    z-index: 2;
                    cursor: pointer;
                }
                .scroll_empty{
                    margin-top: 100px;
                }
                .scroll_content_background{
                    position: fixed;
                    z-index: 1;
                    width: 100%;
                    bottom: 0;
                    left: 0;
                }
            }
        }
    }
    @media only screen and (max-width:1024px) {
        .tt_work_list{
            .work_list_head{
                width: 966px;
            }
            .work_list_scroll{
                min-width: 1024px;
                .list_scroll_content{
                    width: 966px;
                }
            }
        }
    }
</style>
<style lang="scss">
    .tt_work_list_dropdown_schoolYear{
        .active{
            background-color: #ecf5ff;
            color: #66b1ff;
        }
    }
</style>
